const colors = {
  background: '#eeeeee',
  text: '#333333',
  accent: '#42537D',
  highlight: '#ffffff',
  sensei: '#B9BA57',
  glow: '#FFFFCC',
  // '0': '#BBBBBB',
  // '1': '#BAB957',
  // '2': '#BA9957',
  // '3': '#5ECB65',
  // '4': '#5A73AE',
  // '5': '#8D56AE',
  // '6': '#BA8457',
  // '7': '#BA5A57',
  '8': '#666666',
}

const sizes = {
  navHeight: '4.5rem'
}

export {
  colors,
  sizes
};